import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "value", "onChange", "className", "required", "noClearBtn"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState, useEffect } from "react";
import CloseIcon from "components/common/elsevier/Icons/CloseIcon";
import useDebounce from "components/common/utils/useDebounce";
import { ELSButton } from "components/common/elsevier/Button/Button";
import { InputBase } from "@mui/material";
import Styles from "./Styles.module.scss";
function Search(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange,
    className = _ref.className,
    required = _ref.required,
    noClearBtn = _ref.noClearBtn,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(value),
    key = _useState[0],
    setkey = _useState[1];
  useEffect(function () {
    setkey(value);
  }, [value]);
  var debouncedSearch = useDebounce(function (newValue) {
    onChange(newValue);
  }, 50, [onChange]);
  var handleChange = useCallback(function (_ref2) {
    var newValue = _ref2.target.value;
    setkey(newValue);
    debouncedSearch(newValue);
  }, [setkey]);
  var handleClear = useCallback(function () {
    if (key !== "") {
      setkey("");
      debouncedSearch("");
    }
  }, [key, setkey, debouncedSearch]);
  if (!label) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(Styles.search, " ev-search-input-container ").concat(className !== null && className !== void 0 ? className : "")
    }, /*#__PURE__*/React.createElement(InputBase, {
      "data-cy": "search-documents-input",
      className: "search-input-row",
      inputProps: _objectSpread({
        value: key,
        onChange: handleChange,
        required: required,
        "aria-label": props.placeholder
      }, props)
    }), key && !noClearBtn && /*#__PURE__*/React.createElement(ELSButton, {
      type: "button",
      onClick: handleClear,
      "aria-label": "clear search",
      className: "es-button__mail-icon"
    }, /*#__PURE__*/React.createElement(CloseIcon, null)));
  }
  return /*#__PURE__*/React.createElement("label", {
    className: "".concat(Styles.search, " ev-search-input-container ").concat(className !== null && className !== void 0 ? className : "")
  }, label && /*#__PURE__*/React.createElement("span", {
    "data-cy": "search-documents-label"
  }, label, required && /*#__PURE__*/React.createElement("span", null, "*")), /*#__PURE__*/React.createElement(InputBase, {
    "data-cy": "search-documents-input",
    className: "search-input-row",
    inputProps: _objectSpread({
      value: key,
      onChange: handleChange,
      required: required
    }, props)
  }), key && !noClearBtn && /*#__PURE__*/React.createElement(ELSButton, {
    type: "button",
    onClick: handleClear,
    "aria-label": "clear search",
    className: "es-button__mail-icon"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)));
}
Search.defaultProps = {
  label: "Search documents",
  value: "",
  onChange: function onChange() {}
};
export default Search;